<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card bg-secondary shadow border-0">
        <!-- <div class="card-header bg-transparent pb-5">
                    <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                    <div class="btn-wrapper text-center">
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                            <span class="btn-inner--text">Github</span>
                        </a>
                        <a href="#" class="btn btn-neutral btn-icon">
                            <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                            <span class="btn-inner--text">Google</span>
                        </a>
                    </div>
                </div> -->
        <div class="card-body px-lg-5 py-lg-4">
          <div class="text-center text-muted mb-4">
            <small>Sign in with credentials</small>
          </div>
          <form role="form">
            <div class="mb-3">
              <base-input
                class="input-group-alternative mb-0"
                placeholder="Email"
                :class="{ 'has-danger input-danger': emailErr }"
                type="email"
                @keyup="atInputKeyUps"
                addon-left-icon="ni ni-email-83"
                @keypress.enter="login"
                v-model="model.email"
              >
              </base-input>
              <span
                v-show="emailErr"
                class="text-danger"
                v-text="emailMsg"
              ></span>
            </div>

            <div class="mb-3">
              <base-input
                class="input-group-alternative mb-0"
                placeholder="Password"
                :class="{ 'has-danger input-danger': passwordErr }"
                type="password"
                @keyup="atInputKeyUps"
                addon-left-icon="ni ni-lock-circle-open"
                @keypress.enter="login"
                v-model="model.password"
              >
              </base-input>
              <span
                v-show="passwordErr"
                class="text-danger"
                v-text="passwordMsg"
              ></span>
            </div>

            <base-checkbox class="custom-control-alternative">
              <span class="text-muted">Remember me</span>
            </base-checkbox>
            <div class="text-center">
              <base-button type="primary" class="my-4" @click.prevent="login"
                >Sign in</base-button
              >
            </div>
          </form>
          <div class="row">
            <div class="col-12">
              <router-link to="/forgot/password" class="text-dark"
                ><small>Forgot password?</small></router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/apiList";
export default {
  name: "login",
  data() {
    return {
      model: {
        email: "",
        password: "",
      },
      emailErr: false,
      passwordErr: false,
      emailMsg: "",
      passwordMsg: "",
    };
  },
  methods: {
    async login() {
      if (this.validateForm()) {
        let { email, password } = this.model;
        this.emailErr = false;
        this.passwordErr = false;
        let body = { email, password };
        this.$store.dispatch("toggleLoader", true);
        const data = await api.login(body);
        if (!data.response) {
          let res = data.data.data;
          let { token, user } = res;
          let userData = JSON.stringify({ token, user });
          localStorage.setItem("user-session", userData);
          this.parseUserToken();
          this.$router.push({ path: "dashboard" });
          this.$toast("Welcome to Quran Admin Panel!", {
            type: "info",
          });
        } else {
          let res = data.response;
          this.$toast(res.data.message, {
            type: "error",
          });
        }
        this.$store.dispatch("toggleLoader", false);
      }
    },
    validateForm() {
      let { email, password } = this.model;
      let hasErr = false;
      if (!email) {
        this.emailErr = true;
        this.emailMsg = "Email is required.";
        hasErr = true;
      }
      if (!password) {
        this.passwordErr = true;
        this.passwordMsg = "Password is required.";
        hasErr = true;
      }
      return !hasErr;
    },
    atInputKeyUps(inputName) {
      if (this.model.email) this.emailErr = false;
      if (this.model.password) this.passwordErr = false;
    },

    async parseUserToken() {
      let user_session = JSON.parse(localStorage.getItem("user-session"));
      let token = null;
      if (user_session) {
        token = user_session.token;
      }
      if (token) {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
          atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        this.$store.dispatch("populateUserData", JSON.parse(jsonPayload));
      }
    },
  },
};
</script>
<style scoped>
.input-danger {
  border: 1px solid red;
}
.text-danger {
  color: red;
  font-size: 14px;
}
.text-dark {
  color: #324cdd !important;
  text-decoration: underline;
}
</style>
